import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { customSegmentRef } from './consts';

export default grapesjs.plugins.add('zerocode-customsegment', (editor, opts = {}) => {
  let defaults = {
    blocks: [customSegmentRef],
    labelCustomSegmentCategory: 'Advanced',
    labelCustomSegment: 'Custom Segment',
    pfx: 'customsegment',
  };

  for (let name in defaults) {
    if (!(name in opts)) opts[name] = defaults[name];
  }

  loadComponents(editor, opts);
  loadBlocks(editor, opts);
});
